// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3bz3f","containerItemsCenter":"Skeleton_containerItemsCenter__2mtZH"};